export default __webpack_public_path__ + "966cf27dc78d3f2cf477fdf4a77934ba.png";